import {
    Notification,
    NotificationType,
} from '@instinet-analytics/semantic-ui-components';

export interface NotifyableActionPayload {
    title?: string;
    message: string;
    type: NotificationType;
}

export interface NotifyableAction {
    notification: NotifyableActionPayload;
}

export default interface NotificationState {
    notifications: Notification[];
    archived: Notification[];
}

export const initialNotificationState: NotificationState = {
    archived: [],
    notifications: [],
};
